import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './TeamMemberDetails.scss'
import '../../../../../pages/styles.scss'
import FooterSection from '../../../../../../components/reusable/HomePageSections/FooterSection/FooterSection.js';

const TeamMemberDetails = () => {
    const location = useLocation();
    useEffect(() => {
        document.documentElement.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant'
        });
        document.body.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant'
        });
    }, [location.search]);
    const { image, name, pageType, designation, message } = location.state || {};

    if (!image || !name || !pageType || !designation || !message) {
        return <div>No team member details available.</div>;
    }

    return (
        <div className='team-member-details-container container'>
            <div className='team-member-details-section section-1'>
                <div className='team-member-details-section-content text'>
                    <div className='teamName'>
                        <span>{pageType}</span>
                    </div>
                    <br />
                    <h1>{name}</h1>
                    <p>{designation}</p>
                </div>
                <div className='team-member-details-section-content image'>
                    <div className='image-container'>
                        <img src={image} alt="" />
                    </div>
                </div>
            </div>
            <div className='team-member-details-section section-2'>
                <div className='team-member-details-section-content text'>
                    {message.map((line, index) => (
                        <React.Fragment key={index}>
                            <p>{line}</p>
                            <br />
                        </React.Fragment>
                    ))}
                </div>
            </div>
            <FooterSection />
        </div>
    );
};

export default TeamMemberDetails;
